import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  navigate(event) {
    window.location.href = this.element.dataset.url
  }

  stopPropagation(event) {
    event.stopPropagation()
  }
} 